export enum HomeOwnershipInformationLabel {
  MoveInDate = 'Purchase Date',
  OwnershipStatus = 'Ownership Status',
  PreviousStreetAddress = 'Previous Street Address',
  PreviousCity = 'Previous City',
  PreviousState = 'Previous State',
  PreviousZip = 'Previous Zip Code',
  PreviousMoveInDate = 'Previous Move In Date',
}

export enum HomeOwnershipInformationFieldName {
  MoveInDate = 'purchase_date',
  OwnershipStatus = 'ownership_status',
  HireDate = 'previous_employment_hire_date',
}

export enum OwnershipLabel {
  OwnWithMortgage = 'Own with Mortgage',
  OwnFreeClear = 'Own Free & Clear',
  Rent = 'Rent',
  LiveWithParents = 'Live With Parents',
}
